export function arrayBufferPromise(documentId) {
    return fetch(`${process.env.REACT_APP_LAWS_BACKEND_HOST}/docs/v1/documents/getContent?documentId=` + documentId)
        .then(response => response.arrayBuffer())
        .then((data) => {
            return data;
        })
}